/*
商談予約詳細ページの初期化
*/
import axios from "axios";
export function initReservationDetail() {
    const reservationDetailArticle = document.querySelector("[data-reservation-detail-article]");
    if (!reservationDetailArticle)
        return;
    initReservationEditModal();
    initReservationEditButton();
    initConfirmButton();
}
// 商談予約編集モーダルの初期化
function initReservationEditModal() {
    const selectDaysElement = document.querySelector("[data-reservation-edit-days]");
    if (!selectDaysElement)
        throw new Error("'selectDaysElement' is not found");
    const selectTimesElement = document.querySelector("[data-reservation-edit-times]");
    const selectMeetingTypesElement = document.querySelector("[data-reservation-edit-meeting-type]");
    // 日付を選択した際に予約可能な時間のoptionsと商談方法の生成
    selectDaysElement.addEventListener("change", function () {
        const selectedDay = selectDaysElement.options[selectDaysElement.selectedIndex];
        const timesData = JSON.parse(selectedDay.dataset.reservationFramesOfTheDay);
        const meetingTypes = JSON.parse(selectedDay.dataset.reservationFramesOfTheDayMeetingType);
        generateMeetingType(selectMeetingTypesElement, meetingTypes);
        const selectedMeetingType = getSelectedMeetingType(selectMeetingTypesElement);
        generateTimeOptions(selectTimesElement, selectDaysElement, timesData, selectedMeetingType === '展示会商談');
    });
    selectMeetingTypesElement.addEventListener("change", function () {
        const selectedDay = selectDaysElement.options[selectDaysElement.selectedIndex];
        const timesData = JSON.parse(selectedDay.dataset.reservationFramesOfTheDay);
        const selectedMeetingType = getSelectedMeetingType(selectMeetingTypesElement);
        generateTimeOptions(selectTimesElement, selectDaysElement, timesData, selectedMeetingType === '展示会商談');
    });
    const errorMessage = document.getElementById("error-message-filed");
    if (errorMessage) {
        errorMessage.innerHTML = "";
    }
}
function getSelectedMeetingType(selectElement) {
    const selectedIndex = selectElement.selectedIndex;
    const options = selectElement.options;
    const selectedText = options[selectedIndex].text;
    const selectedValue = options[selectedIndex].value;
    return selectedValue;
}
// 予約可能な時間帯のoptionを生成する
function generateTimeOptions(selectTimesElement, selectDaysElement, timesData, isNeedSuspend = false) {
    // 既に存在するoptionを削除する
    while (selectTimesElement.lastChild) {
        selectTimesElement.removeChild(selectTimesElement.lastChild);
    }
    // optionの生成
    for (const timeData of timesData) {
        if ('is_suspend_date' in timeData && isNeedSuspend && timeData.is_suspend_date) {
            continue;
        }
        const insertOption = document.createElement("option");
        insertOption.value = String(timeData.id);
        insertOption.text = timeData.reserve_start_at;
        selectTimesElement.appendChild(insertOption);
    }
}
function generateMeetingType(selectMeetingTypesElement, meetingTypes) {
    while (selectMeetingTypesElement.lastChild) {
        selectMeetingTypesElement.removeChild(selectMeetingTypesElement.lastChild);
    }
    for (const meetingType of meetingTypes) {
        const insertOption = document.createElement("option");
        insertOption.value = meetingType;
        insertOption.text = meetingType;
        selectMeetingTypesElement.appendChild(insertOption);
    }
}
// 商談予約変更の確定ボタンの初期化
function initReservationEditButton() {
    const reservationEditCompleteButton = document.querySelector("[data-reservation-edit-complete-button]");
    if (!reservationEditCompleteButton)
        throw new Error("'reservationEditCompleteButton' is not found");
    reservationEditCompleteButton.addEventListener("click", function () {
        const reservationId = document.querySelector("[name=reserved_id]").value;
        const reservationFrameId = document.querySelector("[name=reservation_frame_id]").value;
        const meetingType = document.querySelector("[name=meeting_type]").value;
        const participantSize = document.querySelector("[name=participant_size]").value;
        const sendData = {
            reservation_id: reservationId,
            reservation_frame_id: reservationFrameId,
            meeting_type: meetingType,
            participant_size: participantSize,
        };
        axios
            .post("/api/u/mypage/reservation/detail/edit", sendData)
            .then((response) => {
            window.console.log(response);
            // ボタンと変更完了の表示を切り替える
            const reservationEditButtonArea = document.querySelector("[data-reservation-edit-button-area]");
            if (!reservationEditButtonArea)
                throw new Error("'reservationEditButtonArea' is not found");
            reservationEditButtonArea.classList.add("area-hide");
            const reservationEditNotificationArea = document.querySelector("[data-reservation-edit-notification-area]");
            if (!reservationEditNotificationArea)
                throw new Error("'reservationEditNotificationArea' is not found");
            reservationEditNotificationArea.classList.remove("area-hide");
            location.href = "/u/mypage/reservation/index";
        })
            .catch((error) => {
            if (!axios.isAxiosError(error)) {
                window.console.log(error);
                throw new Error("Error occured.");
            }
            window.console.log(error.response);
            if ((error.response.status === 400 && error.response.data.result === "SizeOver") || (error.response.status === 400 && error.response.data.result === "TimeOver")) {
                const errorMessageText = error.response.data.message;
                const errorMessage = document.getElementById("error-message-filed");
                errorMessage.innerHTML = errorMessageText;
            }
        });
    });
}
function initConfirmButton() {
    const confirmBtn = document.getElementById("reservation-comfirm-button");
    confirmBtn.addEventListener("click", function () {
        confirmButton();
    });
    confirmBtn.addEventListener("touchstart", function () {
        confirmButton();
    });
    const fixBtn = document.getElementById("reservation-fix-button");
    fixBtn.addEventListener("click", function () {
        fixButton();
    });
    fixBtn.addEventListener("touchstart", function () {
        fixButton();
    });
}
function confirmButton() {
    document.getElementById("reservation-message").innerHTML = "内容に問題なければ、【変更を確定する】ボタンで予約の変更を完了させてください。";
    // エラーメッセージの削除
    const errorMessage = document.getElementById("error-message-filed");
    errorMessage.innerHTML = "";
}
function fixButton() {
    document.getElementById("reservation-message").innerHTML = "内容を確認の上、【確認する】ボタンで確認画面へお進みください。";
    // エラーメッセージの削除
    const errorMessage = document.getElementById("error-message-filed");
    errorMessage.innerHTML = "";
}
